import moment from 'moment/moment'
import { xlCol, xlColq } from '../../../common/constants'
import { SHRI_BABU } from '../../../../helper/companyIdhardcode'
export const bookingError = {
  topayLowBalance: 'Booking is not allowed for Selected Payment Type due to Insufficient Balance at Selected Destination Branch'
}
export const pdfHeaderColumn = [
  {
    headerName: 'Source City',
    exportHead: 'Source City',
    field: 'sourceCity',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Source Branch',
    exportHead: 'Source Branch',
    field: 'sourceBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Source Branch User',
    exportHead: 'Source Branch User',
    field: 'sourceBranchUser',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination City',
    exportHead: 'Destination City',
    field: 'destCity',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination Branch',
    exportHead: 'Destination Branch',
    field: 'destBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Payment Type',
    exportHead: 'Payment Type',
    field: 'paymentType',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Txns Type',
    exportHead: 'Txns Type',
    field: 'trnsType',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  { headerName: 'LR Status', exportHead: 'LR Status', field: 'status', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right' },
]
export const filterHeaderColumn = [
  {
    headerName: 'Source City',
    exportHead: 'Source City',
    field: 'sourceCity',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Source Branch',
    exportHead: 'Source Branch',
    field: 'sourceBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Source Branch User',
    exportHead: 'Source Branch User',
    field: 'sourceBranchUser',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination City',
    exportHead: 'Destination City',
    field: 'destCity',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'right',
  },
]
export const filterHeaderColumn1 = [
  {
    headerName: 'Destination Branch',
    exportHead: 'Destination Branch',
    field: 'destBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Payment Type',
    exportHead: 'Payment Type',
    field: 'paymentType',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Txns Type',
    exportHead: 'Txns Type',
    field: 'trnsType',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'LR Status',
    exportHead: 'LR Status',
    field: 'status',
    xlCol: {
      dataType: 'number',
      dataFormatter: null
    },
    align: 'right'
  }
]
export const pdfHeaderColumn1 = [
  {
    headerName: 'Destination Branch',
    exportHead: 'Destination Branch',
    field: 'destBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Payment Type',
    exportHead: 'Payment Type',
    field: 'paymentType',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Txns Type',
    exportHead: 'Txns Type',
    field: 'trnsType',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  { headerName: 'LR Status', exportHead: 'LR Status', field: 'status', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right' },
]
export const pdfFranchiseeHeaderColumn = [
  {
    headerName: 'Source City',
    exportHead: 'Source City',
    field: 'sourceCity',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Source Branch',
    exportHead: 'Source Branch',
    field: 'sourceBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Source Branch User',
    exportHead: 'Source Branch User',
    field: 'sourceBranchUser',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Franchisee Company',
    exportHead: 'Franchisee Company',
    field: 'destCity',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
]
export const pdfFranchiseeHeaderColumn1 = [
  {
    headerName: 'Franchisee Branch',
    exportHead: 'Franchisee Branch',
    field: 'destBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Payment Type',
    exportHead: 'Payment Type',
    field: 'paymentType',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Txns Type',
    exportHead: 'Txns Type',
    field: 'trnsType',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  { headerName: 'LR Status', exportHead: 'LR Status', field: 'status', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right' },
]
export const ownBookingDetailedColumn = [
  {
    headerName: 'SN',
    exportHead: 'SN',
    field: 'srNo',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
  },
  {
    headerName: 'LR No.\nMan.LR No.',
    exportHead: 'LR No.\nMan. LR No.',
    field: 'LRNO',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
  },
  {
    headerName: 'Dest. City\nDest. Br.',
    exportHead: 'Dest. City\nDest. Br.',
    field: 'DstCityBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
  },
  {
    headerName: 'Bkg. Time\nBkg. By',
    exportHead: 'Bkg. Time \n Bkg. By',
    field: 'BkgDtTimeBy',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
  },
  {
    headerName: 'Sndr. Name\nSndr. GSTIN',
    exportHead: 'Sndr. Name \n Sndr. GSTIN',
    field: 'SenderNameGSTN',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
  },
  {
    headerName: 'Rcvr. Name\nRcvr. GSTIN',
    exportHead: 'Rcvr. Name \n Rcvr. GSTIN',
    field: 'recNameGstin',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
  },
  {
    headerName: 'Pymt.\nType',
    exportHead: 'Pymt.\nType',
    field: 'PayType',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
  },
  {
    headerName: 'Item\nDesc. ',
    exportHead: 'Item\nDesc. ',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
  },
  {
    headerName: 'LR\nStatus',
    exportHead: 'LR\nStatus',
    field: 'STATUS',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
  },
  {
    header: 'Booking\nTransaction ID',
    exportHead: 'Booking\nTransaction ID',
    field: 'BookedResponse',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left'
  },
  {
    header: 'Delivery Transaction\nID',
    exportHead: 'Delivery Transaction\nID',
    field: 'DeliveredResponse',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left'
  },
  {
    headerName: 'Item\nUnits',
    exportHead: 'Item\nUnits',
    field: 'MOP',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
  },
  {
    headerName: 'Frt.\nChrg.',
    exportHead: 'Frt.\nChrg.',
    field: 'Freight',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
  },
  {
    headerName: 'Cart.\nChrg',
    exportHead: 'Cart.\nChrg',
    field: 'CartageAmount',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
  },
  {
    headerName: 'Ham.\nChrg.',
    exportHead: 'Ham.\nChrg.',
    field: 'HamaliCharges',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
  },
  {
    headerName: 'Doc.\nChrg.',
    exportHead: 'Doc.\nChrg.',
    field: 'DocumentCharges',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
  },
  {
    headerName: 'Val.\nChrg.',
    exportHead: 'Val.\nChrg.',
    field: 'Valuation',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
  },
  {
    headerName: 'Oth.\nChrg.',
    exportHead: 'Oth.\nChrg.',
    field: 'OtherCharges',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
  },
  {
    headerName: 'Bkg.\nGST',
    exportHead: 'Bkg.\nGST',
    field: 'BookingGST',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
  },
  {
    headerName: 'Net\n Amt.',
    exportHead: 'Net\n Amt.',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
  },
]
export const ownBookingDetailedColumns = [
  {
    id: 0, header: 'SN', exportHead: 'SN', field: 'srNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 37, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 1, header: 'LR No.\nMan.LR No.', exportHead: 'LR No.\nMan.LR No.', field: 'LRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 2, header: 'Dest. City\nDest. Br.', exportHead: 'Dest. City\nDest. Br.', field: 'DstCityBranch', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 3, header: 'Bkg. Time\nBkg. By', exportHead: 'Bkg. Time\nBkg. By', field: 'BkgDtTimeBy', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 4, header: 'Sndr. Name\nSndr. GSTIN', exportHead: 'Sndr. Name\nSndr. GSTIN', field: 'SenderNameGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 5, header: 'Sndr. Cont.\nSndr. Email', exportHead: 'Sndr. Cont.\nSndr. Email', field: 'SenderContEmail', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 6, header: 'Rcvr. Name\nRcvr. GSTIN', exportHead: 'Rcvr. Name\nRcvr. GSTIN', field: 'recNameGstin', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 7, header: 'Rcvr. Cont.\nRcvr. Email', exportHead: 'Rcvr. Cont.\nRcvr. Email', field: 'RecContEmail', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 8, header: 'Pymt.\nType', exportHead: 'Pymt.\nType', field: 'PayType', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 90, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 9, header: 'Item\nDesc.', exportHead: 'Item\nDesc.', field: 'ItemDetails', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 10, header: 'LR\nStatus', exportHead: 'LR\nStatus', field: 'STATUS', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  // {
  //   id: 11, header: 'Booking\nTransaction ID', exportHead: 'Booking\nTransaction ID', field: 'BookedResponse', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
  //   pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
  //   headerSx: { textAlign: 'left' }
  // },
  // {
  //   id: 12, header: 'Delivery\nTransaction ID', exportHead: 'Delivery\nTransaction ID', field: 'DeliveredResponse', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
  //   pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
  //   headerSx: { textAlign: 'left' }
  // },
  {
    id: 13, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'MOP', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 100, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 14, header: 'Frt.\nChrg.', exportHead: 'Frt.\nChrg.', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 15, header: 'Cart.\nChrg', exportHead: 'Cart.\nChrg', field: 'CartageAmount', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 16, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 17, header: 'Doc.\nChrg.', exportHead: 'Doc.\nChrg.', field: 'DocumentCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 18, header: 'Val.\nChrg.', exportHead: 'Val.\nChrg.', field: 'Valuation', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 19, header: 'Oth.\nChrg.', exportHead: 'Oth.\nChrg.', field: 'OtherCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 20, header: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 21, header: 'Net\nAmt.', exportHead: 'Net\nAmt.', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
]
// Removed GST-related columns for Country ID 2 (Kenya)
export const ownBookingDetailedColumnsTwo = [
  {
    id: 0, header: 'SN', exportHead: 'SN', field: 'srNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 37, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 1, header: 'LR No.\nMan.LR No.', exportHead: 'LR No.\nMan.LR No.', field: 'LRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 2, header: 'Dest. City\nDest. Br.', exportHead: 'Dest. City\nDest. Br.', field: 'DstCityBranch', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 3, header: 'Bkg. Time\nBkg. By', exportHead: 'Bkg. Time\nBkg. By', field: 'BkgDtTimeBy', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 4, header: 'Sndr. Name', exportHead: 'Sndr. Name', field: 'SenderNameGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 5, header: 'Sndr. Cont.\nSndr. Email', exportHead: 'Sndr. Cont.\nSndr. Email', field: 'SenderContEmail', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 6, header: 'Rcvr. Name', exportHead: 'Rcvr. Name', field: 'recNameGstin', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 7, header: 'Rcvr. Cont.\nRcvr. Email', exportHead: 'Rcvr. Cont.\nRcvr. Email', field: 'RecContEmail', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 8, header: 'Rcvr \nAddress', exportHead: 'Rcvr \nAddress', field: 'RecAddress', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 9, header: 'Pymt.\nType', exportHead: 'Pymt.\nType', field: 'PayType', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 90, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 10, header: 'Item\nDesc.', exportHead: 'Item\nDesc.', field: 'ItemDetails', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 11, header: 'LR\nStatus', exportHead: 'LR\nStatus', field: 'STATUS', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 12, header: 'Booking\nTransaction ID', exportHead: 'Booking\nTransaction ID', field: 'BookedResponse', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 13, header: 'Delivery\nTransaction ID', exportHead: 'Delivery\nTransaction ID', field: 'DeliveredResponse', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 14, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'MOP', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 100, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 15, header: 'Frt.\nChrg.', exportHead: 'Frt.\nChrg.', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 16, header: 'Cart.\nChrg', exportHead: 'Cart.\nChrg', field: 'CartageAmount', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 17, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 18, header: 'Doc.\nChrg.', exportHead: 'Doc.\nChrg.', field: 'DocumentCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 19, header: 'Val.\nChrg.', exportHead: 'Val.\nChrg.', field: 'Valuation', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 20, header: 'Oth.\nChrg.', exportHead: 'Oth.\nChrg.', field: 'OtherCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  // {
  //   id: 20, header: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
  //   pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
  //   headerSx: { textAlign: 'right' }
  // },
  {
    id: 21, header: 'Net\nAmt.', exportHead: 'Net\nAmt.', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
]
export const ownBookingDetailedColumnsWithFormattedLR = [
  {
    id: 0, header: 'SN', exportHead: 'SN', field: 'srNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 37, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 1, header: 'LR No.\nMan.LR No.', exportHead: 'LR No.\nMan.LR No.', field: 'LRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 2, header: 'Formatted\nLR No.', exportHead: 'Formatted\nLR No.', field: 'FormattedLRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 3, header: 'Dest. City\nDest. Br.', exportHead: 'Dest. City\nDest. Br.', field: 'DstCityBranch', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 4, header: 'Bkg. Time\nBkg. By', exportHead: 'Bkg. Time\nBkg. By', field: 'BkgDtTimeBy', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 5, header: 'Sndr. Name\nSndr. GSTIN', exportHead: 'Sndr. Name\nSndr. GSTIN', field: 'SenderNameGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 6, header: 'Sndr. Cont.\nSndr. Email', exportHead: 'Sndr. Cont.\nSndr. Email', field: 'SenderContEmail', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 7, header: 'Rcvr. Name\nRcvr. GSTIN', exportHead: 'Rcvr. Name\nRcvr. GSTIN', field: 'recNameGstin', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 8, header: 'Rcvr. Cont.\nRcvr. Email', exportHead: 'Rcvr. Cont.\nRcvr. Email', field: 'RecContEmail', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 9, header: 'Pymt.\nType', exportHead: 'Pymt.\nType', field: 'PayType', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 90, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 10, header: 'Item\nDesc.', exportHead: 'Item\nDesc.', field: 'ItemDetails', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 11, header: 'LR\nStatus', exportHead: 'LR\nStatus', field: 'STATUS', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  // {
  //   id: 12, header: 'Booking\nTransaction ID', exportHead: 'Booking\nTransaction ID', field: 'BookedResponse', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
  //   pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
  //   headerSx: { textAlign: 'left' }
  // },
  // {
  //   id: 13, header: 'Delivery\nTransaction ID', exportHead: 'Delivery\nTransaction ID', field: 'DeliveredResponse', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
  //   pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
  //   headerSx: { textAlign: 'left' }
  // },
  {
    id: 12, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'MOP', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 100, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 13, header: 'Frt.\nChrg.', exportHead: 'Frt.\nChrg.', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 14, header: 'Cart.\nChrg', exportHead: 'Cart.\nChrg', field: 'CartageAmount', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 15, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 16, header: 'Doc.\nChrg.', exportHead: 'Doc.\nChrg.', field: 'DocumentCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 18, header: 'Val.\nChrg.', exportHead: 'Val.\nChrg.', field: 'Valuation', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 19, header: 'Oth.\nChrg.', exportHead: 'Oth.\nChrg.', field: 'OtherCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 20, header: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 21, header: 'Net\nAmt.', exportHead: 'Net\nAmt.', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
]
// Removed GST-related columns for Country ID 2 (Kenya)
export const ownBookingDetailedColumnsWithFormattedLRTwo =(UseFormattedLRinReports,loginCountryId,UseToPayAsCOD,intCompanyID,dashboard=false)=>{
  const  senderNameGSTIN=loginCountryId === 2 ?'Sndr. Name':'Sndr. Name\nSndr. GSTIN'
  return [
  {
    id: 0, header: 'SN', exportHead: 'SN', field: 'srNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 37, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: false, weight:80
  },
  {
    id: 1, header: 'LR No.\nMan.LR No.', exportHead: 'LR Number\nManual LR Number', field: 'LRNO^^ManualLRNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true, weight:120
  },
  UseFormattedLRinReports===3&&{
    id: 23, header: 'Formatted\nLR No.', exportHead: 'Formatted LR No.', field: 'FormattedLRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  !dashboard&&{
    id: 25, header: 'Reference\nID', exportHead: 'Reference\nID', field: 'ReferenceID', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  dashboard===true&&{
    id: 93, header: 'Src. City\nSrc. Br.', exportHead: 'Source City\nSource Branch', field: 'SourceCityName^^SourceBranchName', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  {
    id: 2, header: 'Dest. City\nDest. Br.', exportHead: 'Destination City\nDestination Branch', field: 'DestCityName^^DestBranchName', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  {
    id: 3, header: 'Bkg. Time\nBkg. By', exportHead: 'Booking Time\nBooking By', field: 'BkgDtTime^^UserBooked', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  {
    id: 4, header: senderNameGSTIN, exportHead: 'Sender Name\nSender GSTIN', field: 'Sender^^SenderGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  {
    id: 5, header:intCompanyID === SHRI_BABU?'Sndr. Email': 'Sndr. Cont.\nSndr. Email', exportHead: intCompanyID === SHRI_BABU?'Sndr. Email': 'Sndr. Cont.\nSndr. Email', field: intCompanyID === SHRI_BABU?'SenderEmailID': 'SenderMobileNo^^SenderEmailID', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  {
    id: 6, header:loginCountryId === 2 ?'Rcvr. Name':'Rcvr. Name\nRcvr. GSTIN', exportHead: loginCountryId === 2 ?'Receiver Name':'Receiver Name\nReceiver GSTIN', field: 'RecName^^RecGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  {
    id: 7, header: intCompanyID === SHRI_BABU?'Rcvr. Email': 'Rcvr. Cont.\nRcvr. Email', exportHead: intCompanyID === SHRI_BABU?'Rcvr. Email': 'Rcvr. Cont.\nRcvr. Email', field: intCompanyID === SHRI_BABU?'ReceiverEmailID': 'RecMobileNo^^ReceiverEmailID', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  loginCountryId===2&&{
    id: 8, header: 'Rcvr \nAddress', exportHead: 'Receiver Address', field: 'RecAddress', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  {
    id: 9, header: 'Pymt.\nType', exportHead: 'Payment Type', field: 'PayType', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 90, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  {
    id: 10, header: 'Item\nDesc.', exportHead: 'Item Description', field: 'Description', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  {
    id: 11, header: 'LR\nStatus', exportHead: 'LR Status', field: 'STATUS', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  loginCountryId===2&&{
    id: 12, header: 'Booking\nTransaction ID', exportHead: 'Booking Transaction ID', field: 'BookedResponse', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  loginCountryId===2&&{
    id: 13, header: 'Delivery\nTransaction ID', exportHead: 'Delivery Transaction ID', field: 'DeliveredResponse', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  {
    id: 14, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'ConsignmentType^^Quantity', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 100, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true
  },
  {
    id: 15, header: 'Frt.\nChrg.', exportHead: 'Freight Charge', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true
  },
  {
    id: 16, header: 'Cart.\nChrg', exportHead: 'Cartage Charge', field: 'CartageAmount', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true
  },
  {
    id: 17, header: 'Ham.\nChrg.', exportHead: 'Hamali Charge', field: 'HamaliCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true
  },
  {
    id: 18, header: 'Doc.\nChrg.', exportHead: 'Document Charge', field: 'DocumentCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true
  },
  {
    id: 19, header: UseToPayAsCOD === 1 ? 'Insu.\nChrg.' : 'Val.\nChrg.', exportHead: UseToPayAsCOD === 1 ? 'Insurance Charge' : 'Valuation Charge', field: 'Valuation', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true
  },
  {
    id: 20, header: 'Oth.\nChrg.', exportHead: 'Other Charge', field: 'OtherCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true
  },
  loginCountryId!==2&&{
    id: 21, header: 'Bkg.\nGST', exportHead: 'Booking GST', field: 'BookingGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true
  },
  {
    id: 22, header: 'Net\nAmt.', exportHead: 'Net Amount', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true
  },
].filter(Boolean)
}
export const ownBookingDetailedColumnsForPotrate = [
  {
    id: 0, header: 'SN', exportHead: 'SN', field: 'srNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 37, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 1, header: 'LR No.\nMan.LR No.', exportHead: 'LR No.\nMan.LR No.', field: 'LRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 2, header: 'Formatted\nLR No.', exportHead: 'Formatted\nLR No.', field: 'FormattedLRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 3, header: 'Dest. City\nDest. Br.', exportHead: 'Dest. City\nDest. Br.', field: 'DstCityBranch', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 4, header: 'Bkg. Time\nBkg. By', exportHead: 'Bkg. Time\nBkg. By', field: 'BkgDtTimeBy', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 5, header: 'Pymt.\nType', exportHead: 'Pymt.\nType', field: 'PayType', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 90, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 6, header: 'Item\nDesc.', exportHead: 'Item\nDesc.', field: 'ItemDetails', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 7, header: 'LR\nStatus', exportHead: 'LR\nStatus', field: 'STATUS', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 8, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'MOP', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 100, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 9, header: 'Frt.\nChrg.', exportHead: 'Frt.\nChrg.', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 10, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 11, header: 'Doc.\nChrg.', exportHead: 'Doc.\nChrg.', field: 'DocumentCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 12, header: 'Net\nAmt.', exportHead: 'Net\nAmt.', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
]
export const franchiseeTownBookingDetailedColumns = [
  {
    id: 0, header: 'SN', exportHead: 'SN', field: 'srNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 37, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 1, header: 'LR No.\nMan.LR No.', exportHead: 'LR No.\nMan.LR No.', field: 'LRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 2, header: 'Dest. City\nDest. Br.', exportHead: 'Dest. City\nDest. Br.', field: 'DstCityBranch', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 3, header: 'Bkg. Time\nBkg. By', exportHead: 'Bkg. Time\nBkg. By', field: 'BkgDtTimeBy', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 4, header: 'Sndr. Name\nSndr. GSTIN', exportHead: 'Sndr. Name\nSndr. GSTIN', field: 'SenderNameGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 5, header: 'Sndr. Cont.\nSndr. Email', exportHead: 'Sndr. Cont.\nSndr. Email', field: 'SenderContEmail', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 6, header: 'Rcvr. Name\nRcvr. GSTIN', exportHead: 'Rcvr. Name\nRcvr. GSTIN', field: 'recNameGstin', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 7, header: 'Rcvr. Cont.\nRcvr. Email', exportHead: 'Rcvr. Cont.\nRcvr. Email', field: 'RecContEmail', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 8, header: 'Pymt.\nType', exportHead: 'Pymt.\nType', field: 'PayType', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 90, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 9, header: 'Item\nDesc.', exportHead: 'Item\nDesc.', field: 'ItemDetails', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 10, header: 'LR\nStatus', exportHead: 'LR\nStatus', field: 'STATUS', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 11, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'Quantity', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 100, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 12, header: 'Frt.\nChrg.', exportHead: 'Frt.\nChrg.', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 13, header: 'Cart.\nChrg', exportHead: 'Cart.\nChrg', field: 'CartageAmount', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 14, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 19, header: 'Doc.\nChrg.', exportHead: 'Doc.\nChrg.', field: 'DocumentCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 15, header: 'Val.\nChrg.', exportHead: 'Val.\nChrg.', field: 'Valuation', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 16, header: 'Oth.\nChrg.', exportHead: 'Oth.\nChrg.', field: 'OtherCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 17, header: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 18, header: 'Net\nAmt.', exportHead: 'Net\nAmt.', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
]
export const franchiseeTownBookingDetailedColumnsWithFormattedLRNO =(UseFormattedLRinReports,loginCountryId,UseToPayAsCOD)=>{
  return [
  {
    id: 0, header: 'SN', exportHead: 'SN', field: 'srNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 37, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' },
    isSortIcon: false
  },
  {
    id: 1, header: 'LR No.\nMan.LR No.', exportHead: 'LR No.\n Manual LR No.', field: 'LRNO^^ManualLRNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' },
    isSortIcon: true
  },
  UseFormattedLRinReports===3&&{
    id: 20, header: 'Formatted\nLR No.', exportHead: 'Formatted\nLR No.', field: 'FormattedLRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' },
    isSortIcon: true
  },
  {
    id: 2, header: 'Dest. City\nDest. Br.', exportHead: 'Destination City\nDestination Branch', field: 'DestCityName^^DestBranchName', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' },
    isSortIcon: true
  },
  {
    id: 3, header: 'Bkg. Time\nBkg. By', exportHead: 'Booking Time\nBooking By', field: 'BkgDtTime^^UserBooked', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' },
    isSortIcon: true
  },
  loginCountryId === 2 ? {
    id: 4, header: 'Sndr. Name', exportHead: 'Sender Name', field: 'Sender', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' },
    isSortIcon: true
  } : {
    id: 4, header: 'Sndr. Name\nSndr. GSTIN', exportHead: 'Sender Name\nSender GSTIN', field: 'Sender^^SenderGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' },
    isSortIcon: true
  },
  {
    id: 5, header: 'Sndr. Cont.\nSndr. Email', exportHead: 'Sender Contact\nSender Email', field: 'SenderMobileNo^^SenderEmailID', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' },
    isSortIcon: true
  },
  {
    id: 6, header:loginCountryId===2?'Rcvr. Name':'Rcvr. Name\nRcvr. GSTIN', exportHead: loginCountryId===2?'Receiver Name':'Receiver Name\nReceiver GSTIN', field: 'RecName^^RecGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' },
    isSortIcon: true
  },
  {
    id: 7, header: 'Rcvr. Cont.\nRcvr. Email', exportHead: 'Receiver Contact\nReceiver Email', field: 'RecMobileNo^^ReceiverEmailID', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' },
    isSortIcon: true
  },
  {
    id: 8, header: 'Pymt.\nType', exportHead: 'Payment Type', field: 'PayType', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 90, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' },
    isSortIcon: true
  },
  {
    id: 9, header: 'Item\nDesc.', exportHead: 'Item Description', field: 'ItemDetails', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' },
    isSortIcon: true
  },
  {
    id: 10, header: 'LR\nStatus', exportHead: 'LR Status', field: 'STATUS', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' },
    isSortIcon: true
  },
  {
    id: 11, header: 'Item\nUnits', exportHead: 'Item Units', field: 'Quantity', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 150, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' },
    isSortIcon: true
  },
  {
    id: 12, header: 'Frt.\nChrg.', exportHead: 'Freight Charge', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' },
    isSortIcon: true
  },
  {
    id: 13, header: 'Cart.\nChrg', exportHead: 'Cartage Charge', field: 'CartageAmount', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' },
    isSortIcon: true
  },
  {
    id: 14, header: 'Ham.\nChrg.', exportHead: 'Hamali Charge', field: 'HamaliCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' },
    isSortIcon: true
  },
  {
    id: 15, header: 'Doc.\nChrg.', exportHead: 'Document Charge', field: 'DocumentCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' },
    isSortIcon: true
  },
  {
    id: 16, header: UseToPayAsCOD===1?'Insu.\nChrg.':'Val.\nChrg.', exportHead: UseToPayAsCOD===1?'Insurance Charge':'Valuation Charge', field: 'Valuation', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' },
    isSortIcon: true
  },
  {
    id: 17, header: 'Oth.\nChrg.', exportHead: 'Other Charge', field: 'OtherCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' },
    isSortIcon: true
  },
  loginCountryId!==2&&{
    id: 18, header: 'Bkg.\nGST', exportHead: 'Booking GST', field: 'BookingGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' },
    isSortIcon: true
  },
  {
    id: 19, header: 'Net\nAmt.', exportHead: 'Net Amount', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' },
    isSortIcon: true
  },
].filter(Boolean)
}
export const franchiseeTownBookingDetailedorPotrateColumns = [
  {
    id: 0, header: 'SN', exportHead: 'SN', field: 'srNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 37, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 1, header: 'LR No.\nMan.LR No.', exportHead: 'LR No.\nMan.LR No.', field: 'LRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 2, header: 'Formatted\nLR No.', exportHead: 'Formatted\nLR No.', field: 'FormattedLRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 3, header: 'Dest. City\nDest. Br.', exportHead: 'Dest. City\nDest. Br.', field: 'DstCityBranch', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 4, header: 'Bkg. Time\nBkg. By', exportHead: 'Bkg. Time\nBkg. By', field: 'BkgDtTimeBy', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 5, header: 'Pymt.\nType', exportHead: 'Pymt.\nType', field: 'PayType', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 90, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 6, header: 'Item\nDesc.', exportHead: 'Item\nDesc.', field: 'ItemDetails', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 7, header: 'LR\nStatus', exportHead: 'LR\nStatus', field: 'STATUS', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 8, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'Quantity', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 100, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 9, header: 'Frt.\nChrg.', exportHead: 'Frt.\nChrg.', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 10, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 11, header: 'Doc.\nChrg.', exportHead: 'Doc.\nChrg.', field: 'DocumentCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 12, header: 'Net\nAmt.', exportHead: 'Net\nAmt.', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
]
export const franchiseeBookingDetailedColumns = [
  {
    id: 0, header: 'SN', exportHead: 'SN', field: 'srNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 37, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 1, header: 'LR No.\nMan.LR No.', exportHead: 'LR No.\nMan.LR No.', field: 'LRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 2, header: 'Dest. City\nDest. Br.', exportHead: 'Dest. City\nDest. Br.', field: 'DstCityBranch', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 3, header: 'Bkg. Time\nBkg. By', exportHead: 'Bkg. Time\nBkg. By', field: 'BkgDtTimeBy', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 4, header: 'Sndr. Name\nSndr. GSTIN', exportHead: 'Sndr. Name\nSndr. GSTIN', field: 'SenderNameGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 5, header: 'Sndr. Cont.\nSndr. Email', exportHead: 'Sndr. Cont.\nSndr. Email', field: 'SenderContEmail', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 6, header: 'Rcvr. Name\nRcvr. GSTIN', exportHead: 'Rcvr. Name\nRcvr. GSTIN', field: 'recNameGstin', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 7, header: 'Rcvr. Cont.\nRcvr. Email', exportHead: 'Rcvr. Cont.\nRcvr. Email', field: 'RecContEmail', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 8, header: 'Pymt.\nType', exportHead: 'Pymt.\nType', field: 'PayType', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 90, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 9, header: 'Item\nDesc.', exportHead: 'Item\nDesc.', field: 'itemDesc', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 10, header: 'LR\nStatus', exportHead: 'LR\nStatus', field: 'STATUS', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 11, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'Quantity', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 100, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 12, header: 'Frt.\nChrg.', exportHead: 'Frt.\nChrg.', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 13, header: 'Cart.\nChrg', exportHead: 'Cart.\nChrg', field: 'CartageAmount', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 14, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 15, header: 'Doc.\nChrg.', exportHead: 'Doc.\nChrg.', field: 'DocumentCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 16, header: 'Val.\nChrg.', exportHead: 'Val.\nChrg.', field: 'Valuation', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 17, header: 'Oth.\nChrg.', exportHead: 'Oth.\nChrg.', field: 'OtherCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 18, header: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 19, header: 'Net\nAmt.', exportHead: 'Net\nAmt.', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
]
export const franchiseeBookingDetailedColumnsWithFormattedLRNO =(UseFormattedLRinReports,loginCountryId)=>{
 return  [
  {
    id: 0, header: 'SN', exportHead: 'Seriel No', field: 'srNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 37, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: false
  },
  {
    id: 1, header: 'LR No.\nMan.LR No.', exportHead: 'LR No.\nMan.LR No.', field: 'LRNO^^ManualLRNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  UseFormattedLRinReports===3&&{
    id: 2, header: 'Formatted\nLR No.', exportHead: 'Formatted LR No.', field: 'FormattedLRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  {
    id: 3, header: 'Dest. City\nDest. Br.', exportHead: 'Destination City\nDestination Branch', field: 'DestinationCity^^DestinationBranch', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  {
    id: 4, header: 'Bkg. Time\nBkg. By', exportHead: 'Booking Time\nBooking By', field: 'BkgDtTime^^UserBooked', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  {
    id: 5, header: 'Sndr. Name\nSndr. GSTIN', exportHead: 'Sender Name\nSender GSTIN', field: 'Sender^^SenderGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  {
    id: 6, header: 'Sndr. Cont.\nSndr. Email', exportHead: 'Sender Contact\nSender Email', field: 'SenderMobileNo^^SenderEmailID', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  {
    id: 7, header: 'Rcvr. Name\nRcvr. GSTIN', exportHead: 'Receiver Name\nReceiver GSTIN', field: 'RecName^^RecGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  {
    id: 8, header: 'Rcvr. Cont.\nRcvr. Email', exportHead: 'Receiver Contact\nReceiver Email', field: 'RecMobileNo^^ReceiverEmailID', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  {
    id: 9, header: 'Pymt.\nType', exportHead: 'Payment Type', field: 'PayType', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 90, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  {
    id: 10, header: 'Item\nDesc.', exportHead: 'Item Description', field: 'ItemDetails', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  {
    id: 11, header: 'LR\nStatus', exportHead: 'LR Status', field: 'STATUS', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true
  },
  {
    id: 12, header: 'Item\nUnits', exportHead: 'Item Units', field: 'Quantity', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 100, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true
  },
  {
    id: 13, header: 'Frt.\nChrg.', exportHead: 'Freight', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true
  },
  {
    id: 14, header: 'Cart.\nChrg', exportHead: 'Cartage Charge', field: 'CartageAmount', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true
  },
  {
    id: 15, header: 'Ham.\nChrg.', exportHead: 'Hamali Charge', field: 'HamaliCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true
  },
  {
    id: 16, header: 'Doc.\nChrg.', exportHead: 'Document Charge', field: 'DocumentCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true
  },
  {
    id: 17, header: 'Val.\nChrg.', exportHead: 'Valuation Charge', field: 'Valuation', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true
  },
  {
    id: 18, header: 'Oth.\nChrg.', exportHead: 'Other Charge', field: 'OtherCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true
  },
  loginCountryId !==2 &&{
    id: 19, header: 'Bkg.\nGST', exportHead: 'Booking GST', field: 'BookingGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true
  },
  {
    id: 20, header: 'Net\nAmt.', exportHead: 'Net Amount', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true
  },
].filter(Boolean)
}
export const franchiseeBookingDetailedColumnsForPortraite = [
  {
    id: 0, header: 'SN', exportHead: 'SN', field: 'srNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 37, cellPadding: 6, font: 'Roboto', fontStyle: "string", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 1, header: 'LR No.\nMan.LR No.', exportHead: 'LR No.\nMan.LR No.', field: 'LRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 2, header: 'Formatted\nLR No.', exportHead: 'Formatted\nLR No.', field: 'FormattedLRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 3, header: 'Dest. City\nDest. Br.', exportHead: 'Dest. City\nDest. Br.', field: 'DstCityBranch', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 4, header: 'Bkg. Time\nBkg. By', exportHead: 'Bkg. Time\nBkg. By', field: 'BkgDtTimeBy', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 5, header: 'Pymt.\nType', exportHead: 'Pymt.\nType', field: 'PayType', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 90, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 6, header: 'Item\nDesc.', exportHead: 'Item\nDesc.', field: 'itemDesc', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 7, header: 'LR\nStatus', exportHead: 'LR\nStatus', field: 'STATUS', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 8, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'Quantity', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 100, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 9, header: 'Frt.\nChrg.', exportHead: 'Frt.\nChrg.', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 14, header: 'Cart.\nChrg', exportHead: 'Cart.\nChrg', field: 'CartageAmount', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 10, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 11, header: 'Doc.\nChrg.', exportHead: 'Doc.\nChrg.', field: 'DocumentCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 12, header: 'Other\nChg.', exportHead: 'Other\nChg.', field: 'OtherCharges', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 12, header: 'Net\nAmt.', exportHead: 'Net\nAmt.', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
]
export const franchiseeBookingDetailedExcelHeader = [
  { halign: 'left', header: 'Serial Number', field: 'srNo' },
  { halign: 'left', header: 'LR Number', field: "LRNO" },
  { halign: 'left', header: 'Manual LR Number', field: "LRNO" },
  { halign: 'left', header: 'Formatted LR Number', field: "FormattedLRNO" },
  { halign: 'left', header: 'Destination City', field: 'DstCityBranch' },
  { halign: 'left', header: 'Destination Branch', field: 'DstCityBranch' },
  { halign: 'left', header: 'Booking Time', field: 'BkgDtTimeBy' },
  { halign: 'left', header: 'Booking By', field: 'BkgDtTimeBy' },
  { halign: 'left', header: 'Sender Name', field: 'SenderNameGSTN' },
  { halign: 'left', header: 'Sender GSTIN', field: 'SenderNameGSTN' },
  { halign: 'left', header: 'Sender Contact', field: 'SenderContEmail' },
  { halign: 'left', header: 'Sender Email', field: 'SenderContEmail' },
  { halign: 'left', header: 'Receiver Name', field: 'recNameGstin' },
  { halign: 'left', header: 'Receiver GSTIN', field: 'recNameGstin' },
  { halign: 'left', header: 'Receiver Contant', field: 'RecContEmail' },
  { halign: 'left', header: 'Receiver Email', field: 'RecContEmail' },
  { halign: 'left', header: 'Payment Type', field: 'PayType' },
  { halign: 'left', header: 'Item Description', field: 'itemDesc' },
  { halign: 'left', header: 'LR Status', field: 'STATUS' },
  { halign: 'left', header: 'Item', field: 'Quantity' },
  { halign: 'right', header: 'Units', field: 'Quantity' },
  { halign: 'right', header: 'Freight Charge', field: 'Freight' },
  { halign: 'right', header: 'Cartage Charge', field: 'CartageAmount' },
  { halign: 'right', header: 'Hamali Charge', field: 'HamaliCharges' },
  { halign: 'right', header: 'Document Charge', field: 'DocumentCharges' },
  { halign: 'right', header: 'Valuaiton Charge', field: 'Valuation' },
  { halign: 'right', header: 'Other Charge', field: 'OtherCharges' },
  { halign: 'right', header: 'Booking GST', field: 'BookingGST' },
  { halign: 'right', header: 'Net Amount', field: 'NetAmount' },
];
export const franchiseeToOwnBookingDetailedExcelHeader = [
  { halign: 'left', header: 'Serial Number', field: 'srNo' },
  { halign: 'left', header: 'LR Number', field: "LRNO" },
  { halign: 'left', header: 'Manual LR Number', field: "LRNO" },
  { halign: 'left', header: 'Formatted LR Number', field: "FormattedLRNO" },
  { halign: 'left', header: 'Destination City', field: 'DstCityBranch' },
  { halign: 'left', header: 'Destination Branch', field: 'DstCityBranch' },
  { halign: 'left', header: 'Booking Time', field: 'BkgDtTimeBy' },
  { halign: 'left', header: 'Booking By', field: 'BkgDtTimeBy' },
  { halign: 'left', header: 'Sender Name', field: 'SenderNameGSTN' },
  { halign: 'left', header: 'Sender GSTIN', field: 'SenderNameGSTN' },
  { halign: 'left', header: 'Sender Contact', field: 'SenderContEmail' },
  { halign: 'left', header: 'Sender Email', field: 'SenderContEmail' },
  { halign: 'left', header: 'Receiver Name', field: 'recNameGstin' },
  { halign: 'left', header: 'Receiver GSTIN', field: 'recNameGstin' },
  { halign: 'left', header: 'Receiver Contant', field: 'RecContEmail' },
  { halign: 'left', header: 'Receiver Email', field: 'RecContEmail' },
  { halign: 'left', header: 'Payment Type', field: 'PayType' },
  { halign: 'left', header: 'Item Description', field: 'itemDesc' },
  { halign: 'left', header: 'LR Status', field: 'STATUS' },
  { halign: 'left', header: 'Item', field: 'Quantity' },
  { halign: 'right', header: 'Units', field: 'Quantity' },
  { halign: 'right', header: 'Freight Charge', field: 'Freight' },
  { halign: 'right', header: 'Cartage Charge', field: 'CartageAmount' },
  { halign: 'right', header: 'Hamali Charge', field: 'HamaliCharges' },
  { halign: 'right', header: 'Document Charge', field: 'DocumentCharges' },
  { halign: 'right', header: 'Valuaiton Charge', field: 'Valuation' },
  { halign: 'right', header: 'Other Charge', field: 'OtherCharges' },
  { halign: 'right', header: 'Booking GST', field: 'BookingGST' },
  { halign: 'right', header: 'Net Amount', field: 'NetAmount' },
];
export const OwnBookingDetailedExcelHeader = [
  { halign: 'left', header: 'Serial Number', field: 'srNo' },
  { halign: 'left', header: 'LR Number', field: "LRNO" },
  { halign: 'left', header: 'Manual LR Number', field: "LRNO" },
  { halign: 'left', header: 'Formatted Lr Number', field: "FormattedLRNO" },
  { halign: 'left', header: 'Destination City', field: 'DstCityBranch' },
  { halign: 'left', header: 'Destination Branch', field: 'DstCityBranch' },
  { halign: 'left', header: 'Booking Time', field: 'BkgDtTimeBy' },
  { halign: 'left', header: 'Booking By', field: 'BkgDtTimeBy' },
  { halign: 'left', header: 'Sender Name', field: 'SenderNameGSTN' },
  { halign: 'left', header: 'Sender GSTIN', field: 'SenderNameGSTN' },
  { halign: 'left', header: 'Sender Contact', field: 'SenderContEmail' },
  { halign: 'left', header: 'Sender Email', field: 'SenderContEmail' },
  { halign: 'left', header: 'Receiver Name', field: 'recNameGstin' },
  { halign: 'left', header: 'Receiver GSTIN', field: 'recNameGstin' },
  { halign: 'left', header: 'Receiver Contact', field: 'RecContEmail' },
  { halign: 'left', header: 'Receiver Email', field: 'RecContEmail' },
  { halign: 'left', header: 'Receiver Address Email', field: 'RecAddress' },
  { halign: 'left', header: 'Payment Type', field: 'PayType' },
  { halign: 'left', header: 'Item Description', field: 'ItemDetails' },
  { halign: 'left', header: 'LR Status', field: 'STATUS' },
  { halign: 'left', header: 'Booking Transaction ID', field: 'BookedResponse' },
  { halign: 'left', header: 'Delivery Transaction ID', field: 'DeliveredResponse' },
  { halign: 'left', header: 'Item', field: 'MOP' },
  { halign: 'right', header: 'Units', field: 'MOP' },
  { halign: 'right', header: 'Freight Charge', field: 'Freight' },
  { halign: 'right', header: 'Cartage Charge', field: 'CartageAmount' },
  { halign: 'right', header: 'Hamali Charge', field: 'HamaliCharges' },
  { halign: 'right', header: 'Document Charge', field: 'DocumentCharges' },
  { halign: 'right', header: 'Valuation Charge', field: 'Valuation' },
  { halign: 'right', header: 'Other Charge', field: 'OtherCharges' },
  { halign: 'right', header: 'Booking GST', field: 'BookingGST' },
  { halign: 'right', header: 'Net Amount', field: 'NetAmount' },
];
export const ownBookingDetailedColumnForExcel = [
  {
    headerName: 'SN',
    exportHead: 'SN',
    field: 'srNo',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'LR No.',
    exportHead: 'LR No.',
    field: 'LRNO',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Man.LR No.',
    exportHead: 'Man. LR No.',
    field: 'ManualLRNo',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Dest. City',
    exportHead: 'Dest. City',
    field: 'DestCityName',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Dest. Br.',
    exportHead: 'Dest. Br.',
    field: 'DestBranchName',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Bkg. Time',
    exportHead: 'Bkg. Time',
    field: 'BkgDtTime',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Bkg. By',
    exportHead: 'Bkg. By',
    field: 'UserBooked',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Sndr. Name',
    exportHead: 'Sndr. Name',
    field: 'Sender',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Sndr. GSTIN',
    exportHead: 'Sndr. GSTIN',
    field: 'SenderGSTN',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Rcvr. Name',
    exportHead: 'Rcvr. Name',
    field: 'RecName',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Rcvr. GSTIN',
    exportHead: 'Rcvr. GSTIN',
    field: 'RecGSTN',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Pymt. \nType',
    exportHead: ' Pymt. \nType',
    field: 'PayType',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Item \nDesc. ',
    exportHead: 'Item \nDesc. ',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'LR\nStatus',
    exportHead: 'LR\nStatus',
    field: 'Status',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Item',
    exportHead: 'Item',
    field: 'MOP',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Units',
    exportHead: 'Units',
    field: 'STATUS',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Frt.\nChrg.',
    exportHead: 'Frt.\nChrg.',
    field: 'Freight',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
    span: 1
  },
  {
    headerName: 'Cart.\nChrg',
    exportHead: 'Cart.\nChrg',
    field: 'CartageAmount',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
    span: 1
  },
  {
    headerName: 'Ham.\nChrg.',
    exportHead: 'Ham.\nChrg.',
    field: 'HamaliCharges',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
    span: 1
  },
  {
    headerName: 'Val.\nChrg.',
    exportHead: 'Val.\nChrg.',
    field: 'Valuation',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
    span: 1
  },
  {
    headerName: 'Oth.\nChrg.',
    exportHead: 'Oth.\nChrg.',
    field: 'OtherCharges',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
    span: 1
  },
  {
    headerName: 'Bkg.\nGST',
    exportHead: 'Bkg.\nGST',
    field: 'BookingGST',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
    span: 1
  },
  {
    headerName: 'Net\nAmt.',
    exportHead: 'Net\nAmt.',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
    span: 2
  },
]
export const ownBookingSummaryColumn =(UseToPayAsCOD)=> [
  { headerName: 'S/N', exportHead: 'S/N', field: 'srNo', xlCol: { dataType: 'string', dataFormatter: null }, minWidth: "80px", align: "left" },
  { headerName: 'Pymt Type', exportHead: ' Pymt Type', field: 'PayType', xlCol: { dataType: 'string', dataFormatter: null }, minWidth: "100px", align: "left" },
  { headerName: 'LR Count', exportHead: 'LR Count', field: 'LRCount', xlCol: { dataType: 'number', dataFormatter: null }, minWidth: "80px", align: "right" },
  { headerName: 'Itm Units', exportHead: 'Itm Units', field: 'ItemUnits', xlCol: { dataType: 'number', dataFormatter: null }, minWidth: "80px", align: "right" },
  { headerName: 'Frt. Chrg', exportHead: 'Frt. Chrg', field: 'Freight', xlCol: { dataType: 'number', dataFormatter: null }, minWidth: "80px", align: "right" },
  { headerName: 'Cart. Chrg', exportHead: 'Cart. Chrg', field: 'CartageAmount', xlCol: { dataType: 'number', dataFormatter: null }, minWidth: "80px", align: "right" },
  { headerName: 'Ham. Chrg', exportHead: 'Ham. Chrg', field: 'HamaliCharges', xlCol: { dataType: 'number', dataFormatter: null }, minWidth: "80px", align: "right" },
  { headerName: UseToPayAsCOD===1?'Insu. Charge':'Val. Chrg', exportHead: UseToPayAsCOD===1?'Insu. Charge':'Val. Chrg', field: 'Valuation', xlCol: { dataType: 'number', dataFormatter: null }, minWidth: "80px", align: "right" },
  { headerName: 'Oth Chrg.', exportHead: 'Oth ham.', field: 'OtherCharges', xlCol: { dataType: 'number', dataFormatter: null }, minWidth: "80px", align: "right" },
  { headerName: 'Bkg. GST', exportHead: 'Bkg. GST', field: 'BookingGST', xlCol: { dataType: 'number', dataFormatter: null }, minWidth: "80px", align: "right" },
  { headerName: 'Total Amt', exportHead: 'Total Amt', field: 'Amount', xlCol: { dataType: 'number', dataFormatter: null }, minWidth: "80px", align: "right" },
  { headerName: 'Ref. Amt', exportHead: 'Ref. Amt', field: 'RefundAmt', xlCol: { dataType: 'number', dataFormatter: null }, minWidth: "80px", align: "right" },
  { headerName: 'Net Amt', exportHead: 'Net Amt', field: 'NetAmount', xlCol: { dataType: 'number', dataFormatter: null }, minWidth: "80px", align: "right" }
]
export const bookingSummaryColumn = [
  { headerName: 'Serial Number', exportHead: 'S/N', field: 'SN', xlCol: xlCol, minWidth: "80px", isSortIcon: false },
  { headerName: 'Payment\nType', exportHead: ' Pymt\nType', field: 'PayType', xlCol: xlCol, minWidth: "100px", isSortIcon: true },
  { headerName: 'LR\nCount', exportHead: 'LR\nCount', field: 'LRCount', xlCol: xlColq, minWidth: "80px", isSortIcon: true },
  { headerName: 'Itm\nUnits', exportHead: 'Itm\nUnits', field: 'ItemUnits', xlCol: xlColq, minWidth: "80px", isSortIcon: true },
  { headerName: 'Freight\nCharge', exportHead: 'Frt\nChrg', field: 'Freight', xlCol: xlColq, minWidth: "80px", isSortIcon: true },
  { headerName: 'Cartage\nCharge', exportHead: 'Cart\nChrg', field: 'CartageAmount', xlCol: xlColq, minWidth: "80px", isSortIcon: true },
  { headerName: 'Hamali\nCharge', exportHead: 'Ham\nChrg', field: 'HamaliCharges', xlCol: xlColq, minWidth: "80px", isSortIcon: true },
  { headerName: 'Valuation\nCharge', exportHead: 'Val\nChrg', field: 'Valuation', xlCol: xlColq, minWidth: "80px", isSortIcon: true },
  { headerName: 'Document\nCharge', exportHead: 'Doc\nChrg', field: 'DocumentCharges', xlCol: xlColq, minWidth: "80px", isSortIcon: true },
  { headerName: 'Other\nCharge', exportHead: 'Oth\nChrg.', field: 'OtherCharges', xlCol: xlColq, minWidth: "80px", isSortIcon: true },
  { headerName: 'Booking\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST', xlCol: xlColq, minWidth: "80px", isSortIcon: true },
  { headerName: 'Total\nAmount', exportHead: 'Total\nAmt', field: 'Amount', xlCol: xlColq, minWidth: "80px", isSortIcon: true },
  { headerName: 'Refund\nAmount', exportHead: 'Ref.\nAmt', field: 'RefundAmt', xlCol: xlColq, minWidth: "80px", isSortIcon: true },
  { headerName: 'Net\nAmount', exportHead: 'Net\nAmt', field: 'NetAmount', xlCol: xlColq, minWidth: "80px", isSortIcon: true }
]

export const detailedHeader = {
  srNo: "SN",
  LRNO: "LR No." + '\n' + "Man LR No",
  FormattedLRNO: 'Formatted\n LR No.',
  DstCityBranch: "Dest. City" + '\n' + "Dest. Branch",
  BkgDtTimeBy: "Bkg. Time" + '\n' + "Bkg. By",
  SenderNameGSTN: "Sndr. Name" + '\n' + "Sndr. GSTIN",
  SenderContEmail: "Sndr. Cont." + '\n' + "Sndr. Email",
  recNameGstin: "Rcvr. Name" + '\n' + "Rcvr. GSTIN",
  RecContEmail: "Rcvr. Cont." + '\n' + "Rcvr. Email",
  PayType: "Pymt." + '\n' + "Type",
  ItemDetails: "Item " + '\n' + "Desc",
  STATUS: "LR" + '\n' + "Status",
  // BookedResponse: "Booking" + '\n' + "Transaction ID",
  // DeliveredResponse: "Delivery" + '\n' + "Transaction ID",
  MOP: "Item" + '\n' + "Units",
  Freight: "Frt." + '\n' + "Chrg.",
  CartageAmount: "Cart." + '\n' + "Chrg.",
  HamaliCharges: "Ham." + '\n' + "Chrg.",
  DocumentCharges: "Doc." + '\n' + "Chrg.",
  Valuation: "Val." + '\n' + "Chrg.",
  OtherCharges: "oth." + '\n' + "Chrg.",
  BookingGST: "Bkg." + '\n' + "GST",
  NetAmount: "Net" + '\n' + "Amt.",
  isHeading: true
}
export const detailedHeaderTwo = {
  srNo: "SN",
  LRNO: "LR No." + '\n' + "Man LR No",
  FormattedLRNO: 'Formatted\n LR No.',
  DstCityBranch: "Dest. City" + '\n' + "Dest. Branch",
  BkgDtTimeBy: "Bkg. Time" + '\n' + "Bkg. By",
  SenderNameGSTN: "Sndr. Name",
  SenderContEmail: "Sndr. Cont." + '\n' + "Sndr. Email",
  recNameGstin: "Rcvr. Name",
  RecContEmail: "Rcvr. Cont." + '\n' + "Rcvr. Email",
  RecAddress: "Rcvr Address",
  PayType: "Pymt." + '\n' + "Type",
  ItemDetails: "Item " + '\n' + "Desc",
  STATUS: "LR" + '\n' + "Status",
  BookedResponse: "Booking" + '\n' + "Transaction ID",
  DeliveredResponse: "Delivery" + '\n' + "Transaction ID",
  MOP: "Item" + '\n' + "Units",
  Freight: "Frt." + '\n' + "Chrg.",
  CartageAmount: "Cart." + '\n' + "Chrg.",
  HamaliCharges: "Ham." + '\n' + "Chrg.",
  DocumentCharges: "Doc." + '\n' + "Chrg.",
  Valuation: "Insu." + '\n' + "Chrg.",
  OtherCharges: "oth." + '\n' + "Chrg.",
  // BookingGST: "Bkg." + '\n' + "GST",
  NetAmount: "Net" + '\n' + "Amt.",
  isHeading: true
}
export const franchiseeToOwnDetailedHeader = {
  srNo: "SN",
  LRNO: "LR No." + '\n' + "Man LR No",
  FormattedLRNO: "Formatte\nLR No.",
  DstCityBranch: "Dest. City" + '\n' + "Dest. Branch",
  BkgDtTimeBy: "Bkg. Time" + '\n' + "Bkg. By",
  SenderNameGSTN: "Sndr. Name" + '\n' + "Sndr. GSTIN",
  SenderContEmail: "Sndr. Cont." + '\n' + "Sndr. Email",
  recNameGstin: "Rcvr. Name" + '\n' + "Rcvr. GSTIN",
  RecContEmail: "Rcvr. Cont." + '\n' + "Rcvr. Email",
  PayType: "Pymt." + '\n' + "Type",
  ItemDetails: "Item " + '\n' + "Desc",
  STATUS: "LR" + '\n' + "Status",
  Quantity: "Item" + '\n' + "Units",
  Freight: "Frt." + '\n' + "Chrg.",
  CartageAmount: "Cart." + '\n' + "Chrg.",
  HamaliCharges: "Ham." + '\n' + "Chrg.",
  DocumentCharges: "Doc." + '\n' + "Chrg.",
  Valuation: "Val." + '\n' + "Chrg.",
  OtherCharges: "oth." + '\n' + "Chrg.",
  BookingGST: "Bkg." + '\n' + "GST",
  NetAmount: "Net" + '\n' + "Amt.",
  isHeading: true
}
export const franchiseeToOwnDetailedHeaderRemoveGST = {
  srNo: "SN",
  LRNO: "LR No." + '\n' + "Man LR No",
  FormattedLRNO: "Formatte\nLR No.",
  DstCityBranch: "Dest. City" + '\n' + "Dest. Branch",
  BkgDtTimeBy: "Bkg. Time" + '\n' + "Bkg. By",
  SenderNameGSTN: "Sndr. Name",
  SenderContEmail: "Sndr. Cont." + '\n' + "Sndr. Email",
  recNameGstin: "Rcvr. Name",
  RecContEmail: "Rcvr. Cont." + '\n' + "Rcvr. Email",
  PayType: "Pymt." + '\n' + "Type",
  ItemDetails: "Item " + '\n' + "Desc",
  STATUS: "LR" + '\n' + "Status",
  Quantity: "Item" + '\n' + "Units",
  Freight: "Frt." + '\n' + "Chrg.",
  CartageAmount: "Cart." + '\n' + "Chrg.",
  HamaliCharges: "Ham." + '\n' + "Chrg.",
  DocumentCharges: "Doc." + '\n' + "Chrg.",
  Valuation: "Val." + '\n' + "Chrg.",
  OtherCharges: "oth." + '\n' + "Chrg.",
  NetAmount: "Net" + '\n' + "Amt.",
  isHeading: true
}

export const franchiseeDetailedHeader = (UseFormattedLRinReports, loginCountryId) => {
  const header = {
    srNo: "SN",
    LRNO: "LR No." + '\n' + "Man LR No",
    FormattedLRNO: "Formatted\nLR No.",
    DstCityBranch: "Dest. City" + '\n' + "Dest. Branch",
    BkgDtTimeBy: "Bkg. Time" + '\n' + "Bkg. By",
    SenderNameGSTN: "Sndr. Name" + '\n' + "Sndr. GSTIN",
    SenderContEmail: "Sndr. Cont" + '\n' + "Sndr. Email",
    recNameGstin: "Rcvr. Name" + '\n' + "Rcvr. GSTIN",
    RecContEmail: "Rcvr. Cont" + '\n' + "Rcvr. EMail",
    PayType: "Pymt." + '\n' + "Type",
    itemDesc: "Item " + '\n' + "Desc",
    STATUS: "LR" + '\n' + "Status",
    Quantity: "Item" + '\n' + "Units",
    Freight: "Frt." + '\n' + "Chrg.",
    CartageAmount: "Cart." + '\n' + "Chrg.",
    HamaliCharges: "Ham." + '\n' + "Chrg.",
    DocumentCharges: "Doc." + '\n' + "Chrg.",
    Valuation: "Val." + '\n' + "Chrg.",
    OtherCharges: "oth." + '\n' + "Chrg.",
    BookingGST: "Bkg." + '\n' + "GST",
    NetAmount: "Net" + '\n' + "Amt.",
    isHeading: true
  }
  if (UseFormattedLRinReports !== 3) {
    delete header.FormattedLRNO;
  }
  if (loginCountryId !== 2) {
    delete header.BookingGST;
  }
  return header;
}
export const detailedHeaderForExcel = {
  srNo: "SN",
  LRNO: "LR No.",
  ManualLRNo: "Man LR No",
  DestCityName: "Dest. City",
  DestBranchName: "Dest. Branch",
  BkgDtTime: "Bkg. Time",
  UserBooked: "Bkg. By",
  Sender: "Sndr. Name",
  SenderGSTN: "Sndr. GSTIN",
  RecName: "Rcvr. Name",
  RecGSTN: "Rcvr. GSTIN",
  PayType: "Pymt." + '\n' + "Type",
  MOP: "Item " + '\n' + "Desc",
  STATUS: "LR" + '\n' + "Status",
  ConsignmentType: "Item",
  Quantity: "Units",
  Freight: "Frt." + '\n' + "Chrg.",
  CartageAmount: "Cart." + '\n' + "Chrg.",
  HamaliCharges: "Ham." + '\n' + "Chrg.",
  Valuation: "Val." + '\n' + "Chrg.",
  OtherCharges: "oth." + '\n' + "Chrg.",
  BookingGST: "Bkg." + '\n' + "GST",
  NetAmount: "Net" + '\n' + "Amt.",
  isHeadingForEx: true
}
export const excelHeader = [
  { col: 1, value: "From Booking Date" },
  { col: 1, value: "To Booking Date" },
  { col: 1, value: "Source City" },
  { col: 2, value: "Source Branch" },
  { col: 2, value: "Source Branch User" },
  { col: 2, value: "Destination City" },
  { col: 2, value: "Destination Branch" },
  { col: 2, value: "Payment Type" },
  { col: 1, value: "Txn. Type" },
  { col: 1, value: "Report View" },
  { col: 2, value: "LR Status" },
]
export const excelHeader1 = [
  { col: 1, value: 'From Booking Date' },
  { col: 1, value: 'To Booking Date' },
  { col: 1, value: 'Source City' },
  { col: 2, value: 'Source Branch' },
  { col: 2, value: 'Source Branch User' },
  { col: 1, value: 'Destination City' },
  { col: 1, value: 'Destination Branch' },
  { col: 1, value: 'Payment Type' },
  { col: 1, value: 'Txn. Type' },
  { col: 1, value: 'Report View' },
  { col: 1, value: 'LR Status' },
]
export const franchiseeExcelHeader = [
  { field: 'DateFrom', value: 'From Booking Date' },
  { field: 'DateTo', value: 'To Booking Date' },
  { field: 'sourceCity', value: 'Source City' },
  { field: 'sourceBranch', value: 'Source Branch' },
  { field: 'sourceBranchUser', value: 'Source Branch User' },
  { field: 'destCity', value: 'Franchisee Company' },
  { field: 'destBranch', value: 'Franchisee Branch' },
  { field: 'paymentType', value: 'Payment Type' },
  { field: 'trnsType', value: 'Txn. Type' },
  { field: 'reportView', value: 'Report View' },
  { field: 'status', value: 'LR Status' },
]
export const franchiseeExcelHeader1 = [
  { col: 2, value: 'From Booking Date' },
  { col: 2, value: 'To Booking Date' },
  { col: 2, value: 'Source City' },
  { col: 3, value: 'Source Branch' },
  { col: 4, value: 'Source Branch User' },
  { col: 3, value: 'Franchisee Company' },
  { col: 3, value: 'Franchisee Branch' },
  { col: 2, value: 'Payment Type' },
  { col: 2, value: 'Txn. Type' },
  { col: 2, value: 'Report View' },
  { col: 2, value: 'LR Status' },
]


export const calculateDynamicFormatLandscape = (desiredWidth) => {
  // Standard A4 landscape aspect ratio: width / height = 297 / 210
  const a4LandscapeAspectRatio = 1122 / 793;

  // Calculate the height based on the aspect ratio
  const dynamicHeight = Math.round(desiredWidth / a4LandscapeAspectRatio);

  return [desiredWidth, dynamicHeight];
};
export const calculateDynamicFormatPortrait = (desiredWidth) => {
  // Standard A4 Portrait aspect ratio: width / height = 297 / 210
  const a4LandscapeAspectRatio = 793 / 1122;

  // Calculate the height based on the aspect ratio
  const dynamicHeight = Math.round(desiredWidth / a4LandscapeAspectRatio);

  return [desiredWidth, dynamicHeight];
};
export const calculateTotalTableWidth = (columns) => {
  let totalWidth = 0;

  columns.forEach((column) => {
    const minCellWidth = column.pdfColSx.minCellWidth;
    totalWidth += minCellWidth;
  });

  return totalWidth;
};

export const generateDynamicColumnStyles = (columnCount, Size) => {
  let columnStyles = {};
  let columnIndex = 0
  // Iterate through each header configuration in BranchTransferHeader
  columnCount.forEach((headerConfig) => {
    if (headerConfig?.isSelected) {
      columnStyles[columnIndex] = { ...headerConfig?.pdfColSx, ["fontSize"]: Size };
      columnIndex += 1
    }

  });

  return columnStyles;
}
export const filterHeaderForFranchiseeToOwn = [
  { header: 'FromDate', field: "fromDate" },
  { header: 'ToDate', field: "toDate" },
  { header: 'Source City', field: "sourceCityName" },
  { header: 'Source Branch', field: "sourceBranchName" },
  { header: 'Source Branch User', field: "SourceBranchUser" },
  { header: 'Destination City', field: "destinationCity" },
]
export const filterHeaderForFranchiseeToOwn1 = [
  { header: 'Destination Branch', field: "destinationBranch" },
  { header: 'Payment Type', field: "paymentType" },
  { header: 'Transaction Type', field: "transactionType" },
  { header: 'Report View', field: "selReportView" },
  { header: 'Status', field: "status" },
  { header: '', field: "" },
]
export const filterHeaderForFranchiseeBooking = [
  { header: 'FromDate', field: "fromDate" },
  { header: 'ToDate', field: "toDate" },
  { header: 'Source City', field: "sourceCityName" },
  { header: 'Source Branch', field: "sourceBranchName" },
  { header: 'Source Branch User', field: "SourceBranchUser" },
  { header: 'Franchisee Company', field: "destinationCity" },
]
export const filterHeaderForFranchiseeBooking1 = [
  { header: 'Franchisee Branch', field: "destinationBranch" },
  { header: 'Payment Type', field: "paymentType" },
  { header: 'Transaction Type', field: "transactionType" },
  { header: 'Report View', field: "selReportView" },
  { header: 'Status', field: "status" },
  { header: '', field: "" },
]
export const filterHeaderForOwnBooking = [
  { header: 'FromDate', field: "fromDate" },
  { header: 'ToDate', field: "toDate" },
  { header: 'Source City', field: "sourceCityName" },
  { header: 'Source Branch', field: "sourceBranchName" },
  { header: 'Source Branch User', field: "SourceBranchUser" },
  { header: 'Destination City', field: "destinationCity" },
]
export const filterHeaderForOwnBooking1 = [
  { header: 'Destination Branch', field: "destinationBranch" },
  { header: 'Payment Type', field: "paymentType" },
  { header: 'Transaction Type', field: "transactionType" },
  { header: 'Report View', field: "selReportView" },
  { header: 'Status', field: "status" },
  { header: '', field: "" },
]
//-------------------changes for pdf-----------------------
export const paymentWiseDrawCell = function (data) {
  var rows = data.table.body
  rows.map((val) => {
    if (data.row.section === 'head') {
      if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
        data.cell.styles.halign = 'right'
      } else {
        data.cell.styles.halign = 'left'
      }
    }
    if (val.raw.isSubHeading) {
      val.cells[0].colSpan = 5
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontSize = '16'
      val.cells[0].styles.textColor = [0, 0, 0]
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = [233, 245, 255]
      val.cells[5].colSpan = 4
      val.cells[5].styles.font = 'Roboto'
      val.cells[5].styles.fontStyle = 'normal'
      val.cells[5].styles.fontSize = '16'
      val.cells[5].styles.textColor = [0, 0, 0]
      val.cells[5].styles.halign = 'left'
      val.cells[5].styles.fillColor = [233, 245, 255]
      val.cells[9].colSpan = 4
      val.cells[9].styles.font = 'Roboto'
      val.cells[9].styles.fontStyle = 'normal'
      val.cells[9].styles.fontSize = '16'
      val.cells[9].styles.textColor = [0, 0, 0]
      val.cells[9].styles.halign = 'right'
      val.cells[9].styles.fillColor = [233, 245, 255]
    }
    if (val.raw.isBooked) {
      val.cells[0].colSpan = 3
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontSize = '16'
      val.cells[0].styles.textColor = [0, 0, 0]
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = [233, 245, 255]
      val.cells[3].colSpan = 4
      val.cells[3].styles.font = 'Roboto'
      val.cells[3].styles.fontStyle = 'normal'
      val.cells[3].styles.fontSize = '16'
      val.cells[3].styles.textColor = [0, 0, 0]
      val.cells[3].styles.halign = 'left'
      val.cells[3].styles.fillColor = [233, 245, 255]
      val.cells[7].colSpan = 3
      val.cells[7].styles.font = 'Roboto'
      val.cells[7].styles.fontStyle = 'normal'
      val.cells[7].styles.fontSize = '16'
      val.cells[7].styles.textColor = [0, 0, 0]
      val.cells[7].styles.halign = 'right'
      val.cells[7].styles.fillColor = [233, 245, 255]
      val.cells[10].colSpan = 3
      val.cells[10].styles.font = 'Roboto'
      val.cells[10].styles.fontStyle = 'normal'
      val.cells[10].styles.fontSize = '16'
      val.cells[10].styles.textColor = [0, 0, 0]
      val.cells[10].styles.halign = 'right'
      val.cells[10].styles.fillColor = [233, 245, 255]
    }
    if (val.raw.isTotal) {
      val.cells[0].colSpan = 2
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontS0ze = '16'
      val.cells[0].styles.textColor = [0, 0, 0]
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = [238, 238, 238]
      for (let i = 2; i <= 12; i++) {
        val.cells[i].colSpan = 1
        val.cells[i].styles.font = 'Roboto'
        val.cells[i].styles.fontStyle = 'normal'
        val.cells[i].styles.fontSize = '16'
        val.cells[i].styles.textColor = [0, 0, 0]
        val.cells[i].styles.halign = i == 0 ? 'left' : 'right'
        val.cells[i].styles.fillColor = [238, 238, 238]
      }
    }
  })
}
export const paymentWiseDrawCellDetail = function (data) {
  var rows = data.table.body
  rows.map((val) => {
    if (data.row.section === 'head') {
      if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
        data.cell.styles.halign = 'right'
      } else {
        data.cell.styles.halign = 'left'
      }
    }
    if (val.raw.isHeading) {
      for (let i = 0; i <= 16; i++) {
        val.cells[i].colSpan = 1
        val.cells[i].styles.font = 'Roboto'
        val.cells[i].styles.fontStyle = 'normal'
        val.cells[i].styles.fontSize = '16'
        val.cells[i].styles.halign = i < 9 ? 'left' : 'right'
        val.cells[i].styles.fillColor = [218, 237, 254]
      }
    }
    if (val.raw.isSubHeading) {
      val.cells[0].colSpan = 6
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontSize = '16'
      val.cells[0].styles.textColor = [0, 0, 0]
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = [233, 245, 255]
      val.cells[6].colSpan = 5
      val.cells[6].styles.font = 'Roboto'
      val.cells[6].styles.fontStyle = 'normal'
      val.cells[6].styles.fontSize = '16'
      val.cells[6].styles.textColor = [0, 0, 0]
      val.cells[6].styles.halign = 'left'
      val.cells[6].styles.fillColor = [233, 245, 255]
      val.cells[11].colSpan = 6
      val.cells[11].styles.font = 'Roboto'
      val.cells[11].styles.fontStyle = 'normal'
      val.cells[11].styles.fontSize = '16'
      val.cells[11].styles.textColor = [0, 0, 0]
      val.cells[11].styles.halign = 'right'
      val.cells[11].styles.fillColor = [233, 245, 255]
    }
    if (val.raw.isTotal) {
      val.cells[0].colSpan = 9
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontS0ze = '16'
      val.cells[0].styles.textColor = [0, 0, 0]
      val.cells[0].styles.halign = 'right'
      val.cells[0].styles.fillColor = [238, 238, 238]
      for (let i = 9; i <= 16; i++) {
        val.cells[i].colSpan = 1
        val.cells[i].styles.font = 'Roboto'
        val.cells[i].styles.fontStyle = 'normal'
        val.cells[i].styles.fontSize = '16'
        val.cells[i].styles.textColor = [0, 0, 0]
        val.cells[i].styles.halign = i == 0 ? 'left' : 'right'
        val.cells[i].styles.fillColor = [238, 238, 238]
      }
    }
  })
}
export const paymentWiseDrawCellSummary = function (data,loginCountryId) {
  var rows = data.table.body
  rows?.map((val) => {
    if (data.row.section === 'head') {
      if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
        data.cell.styles.halign = 'right'
      } else {
        data.cell.styles.halign = 'left'
      }
    }

    if (val.raw.isSupHeading) {
      val.cells[0].colSpan = loginCountryId===2?12:13
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontSize = '16'
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = [233, 245, 255]
    }
    if (val.raw.isSubHeading) {
      val.cells[0].colSpan = 1
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontSize = '16'
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = [233, 245, 255]
      val.cells[1].colSpan = loginCountryId===2?11:12
      val.cells[1].styles.font = 'Roboto'
      val.cells[1].styles.fontStyle = 'normal'
      val.cells[1].styles.fontSize = '16'
      val.cells[1].styles.halign = 'center'
      val.cells[1].styles.fillColor = [233, 245, 255]
    }

    if (val.raw.isHeading) {
      if (loginCountryId===2) {
        for (let i = 0; i <= 11; i++) {
          val.cells[i].colSpan = 1
          val.cells[i].styles.font = 'Roboto'
          val.cells[i].styles.fontStyle = 'normal'
          val.cells[i].styles.fontSize = '16'
          val.cells[i].styles.halign = i < 2 ? 'left' : 'right'
          val.cells[i].styles.fillColor = [218, 237, 254]
        }
      }else{
        for (let i = 0; i <= 12; i++) {
          val.cells[i].colSpan = 1
          val.cells[i].styles.font = 'Roboto'
          val.cells[i].styles.fontStyle = 'normal'
          val.cells[i].styles.fontSize = '16'
          val.cells[i].styles.halign = i < 2 ? 'left' : 'right'
          val.cells[i].styles.fillColor = [218, 237, 254]
        }
      }
      
    }
    if (val.raw.isTotal) {
      val.cells[0].colSpan = 1
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontS0ze = '16'
      val.cells[0].styles.textColor = [0, 0, 0]
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = [238, 238, 238]
      val.cells[1].colSpan = 1
      val.cells[1].styles.font = 'Roboto'
      val.cells[1].styles.fontStyle = 'normal'
      val.cells[1].styles.fontS0ze = '16'
      val.cells[1].styles.textColor = [0, 0, 0]
      val.cells[1].styles.halign = 'left'
      val.cells[1].styles.fillColor = [238, 238, 238]
      if (loginCountryId===2) {
        for (let i = 2; i <= 11; i++) {
          val.cells[i].colSpan = 1
          val.cells[i].styles.font = 'Roboto'
          val.cells[i].styles.fontStyle = 'normal'
          val.cells[i].styles.fontSize = '16'
          val.cells[i].styles.textColor = [0, 0, 0]
          val.cells[i].styles.halign = i == 0 ? 'left' : 'right'
          val.cells[i].styles.fillColor = [238, 238, 238]
        }
      }else{
        for (let i = 2; i <= 12; i++) {
          val.cells[i].colSpan = 1
          val.cells[i].styles.font = 'Roboto'
          val.cells[i].styles.fontStyle = 'normal'
          val.cells[i].styles.fontSize = '16'
          val.cells[i].styles.textColor = [0, 0, 0]
          val.cells[i].styles.halign = i == 0 ? 'left' : 'right'
          val.cells[i].styles.fillColor = [238, 238, 238]
        }
      }
      
    }
  })
}
export const lrDetailPdfFooter = (data, userData, totalPagesExp) => {
  const doc = data.doc
  // Footer
  var pageSize = doc.internal.pageSize
  var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
  var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

  var str = 'Page : ' + doc.internal.getNumberOfPages()
  if (typeof doc.putTotalPages === 'function') {
    str = str + ' of ' + totalPagesExp
  }
  doc.setFontSize(16)
  doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, 'right')
  doc.setFont('Roboto', 'bold')
  doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
  doc.text(
    `Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`,
    doc.internal.pageSize.width / 2 -
    (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize()) / 2 +
    90,
    pageHeight - 5
  )
}

export const ownBookingDetailedColumnsForLeyma = [
  {
    id: 0,header:'SR.', exportHead: 'Serial Number', headerName: 'SR.', field: 'srNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 37, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 1,header:'WB\nNo.',  exportHead: 'WB\nNumber', headerName: 'WB\nNo.', field: 'LRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 2,header:'Src.\nCity', exportHead: 'Source\nCity', headerName: 'Source\nCity', field: 'SourceCityName', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 3,header:'Src.\nBr.', exportHead: 'Source\nBranch', headerName: 'Source\nBranch', field: 'SourceBranchName', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 4,header:'Dest.\nCity', exportHead: 'Destination\nCity', headerName: 'Destination\nCity', field: 'DestinationCity', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 5,header:'Dest.\nBr.', exportHead: 'Destination\nBranch', headerName: 'Destination\nBranch', field: 'DestinationBranch', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 6,header:'Bkg.\nDt.Time', exportHead: 'Booking\nDate Time', headerName: 'Booking\nDate Time', field: 'BkgDtTime', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 150, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 7,header:'BookedBy\nUser', exportHead: 'Booked by\nUser', headerName: 'Booked by\nUser', field: 'UserBooked', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 8,header:'BookedBy.\nBr.', exportHead: 'Booked by\nBranch', headerName: 'Booked by\nBranch', field: 'BookedBranch', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 9,header:'Send.\nName', exportHead: 'Sender\nName', headerName: 'Sender\nName', field: 'Sender', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 10,header:'Send.\nCont.', exportHead: 'Sender\nContact', headerName: 'Sender\nContact', field: 'SenderMobileNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 11,header:'Send.\nRepre.', exportHead: 'Sender\nRepresentative', headerName: 'Sender\nRepresentative', field: 'SenderRepresentativeName', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 12,header:'Rec.\nName.', exportHead: 'Receiver\nName', headerName: 'Receiver\nName', field: 'RecName', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 13,header:'Rec.\nCont.', exportHead: 'Receiver\nContact', headerName: 'Receiver\nContact', field: 'RecMobileNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 14,header:'Rec.\nAdd.', exportHead: 'Receivers\nAddress', headerName: 'Receivers\nAddress', field: 'RecAddress', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 15,header:'Item\nType', exportHead: 'Item\nType', headerName: 'Item\nType', field: 'ConsignmentType', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 16,header:'Pay.\nType', exportHead: 'Payment\nType', headerName: 'Payment\nType', field: 'PayType', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 90, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 17,header:'Units', exportHead: 'Units', headerName: 'Units', field: 'Quantity', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlColq,
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 18,header:'Frt.', exportHead: 'Freight', headerName: 'Freight', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlColq,
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 19,header:'Goods\nVal.', exportHead: 'Goods\nValue', headerName: 'Goods\nValue', field: 'GoodsValue', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlColq,
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 20,header:'Insu.', exportHead: 'Insurance', headerName: 'Insurance', field: 'Valuation', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlColq,
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 21,header:'Total\nAmt', exportHead: 'Total\nAmount', headerName: 'Total\nAmount', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlColq,
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }
  },
  {
    id: 22,header:'Status', exportHead: 'Status', headerName: 'Status', field: 'STATUS', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 23,header:'Bill\nNo.', exportHead: 'BillNumber', headerName: 'BillNo', field: 'PartyBillNo', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 24,header:'Desc.', exportHead: 'Description', headerName: 'Desc.', field: 'Description', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 25, header:'Del.\nOn',exportHead: 'DeliveredOn', headerName: 'DeliveredOn', field: 'DeliveredOn', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 26,header:'Del.\nBy', exportHead: 'DeliveredBy', headerName: 'DeliveredBy', field: 'DeliveredBy', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 27,header:'Book.\nTra. ID', exportHead: 'Booking\nTransaction ID', headerName: 'Booking\nTransaction ID', field: 'BookedResponse', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 28,header:'Deli.\nTra. ID', exportHead: 'Delivery\nTransaction ID', headerName: 'Delivery\nTransaction ID', field: 'DeliveredResponse', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 29,header:'Book.\nPay Bill No.', exportHead: 'Booking\nPay Bill No.', headerName: 'Booking\nPay Bill No.', field: 'BookedPayBillNo', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 30,header:'Deli.\nPay Bill No.', exportHead: 'Delivery\nPay Bill No.', headerName: 'Delivery\nPay Bill No.', field: 'DeliveredPayBillNo', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol,
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
]